import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { ValidatedTextField } from '../../../../../validations/validated-text-field.component'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { ValidatedDateTextField } from '../../../../../validations/validated-date-text-field.component'
import { BeneficiaryInfo } from '../../../../models/enrollments'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { AddressDB } from '../../../../../user-management/models/address'
import { ValidatedSelectOptionModel } from '../../../../../validations/validated-dropdown.component'
import { EmailAddressTextFieldValidator } from '../../../../../validations/email-address-text-field-validator'
import { LengthTextFieldValidator } from '../../../../../validations/length-text-field-validator'
import { DateTextFieldValidator } from '../../../../../validations/date-text-field.validator'
import { RequiredRadioButtonFieldValidator } from '../../../../../validations/required-radio-button-field-validator'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { OtherDrugCoverage } from '../../../../models/enrollments'
import { DrugPlan } from '../../../../models/drug-plan'
import { LicenseApptGateway } from '../../../../../user-management/gateways/license-appt-gateway'
import { StateGateway } from '../../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../../validations/validated-dropdown.component'
import { PortalGlobals } from '../../../../../portalglobals'
import { PlanList } from '../../../../models/plan-list'
import { Router } from '@angular/router'
import * as moment from 'moment'
import { SubmitEnrollmentDataResponse } from '../../../../models/submit-enrollment-data-response'
import { callStartGateway } from '../../../../../call-start/gateways/call-start-gateway'
import { isMMDDYYYY } from '../../../../../../app/validations/is-mmddyyyy'
import { PhoneNumberInputMask } from '../../../../../common/input-masks/phone-number.input-mask'
import * as _ from 'lodash'

@Component({
    selector: 'PhoneEnrollmentExtStep4',
    templateUrl: 'phone-enrollment-step4.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentExtStep4Component implements OnInit {
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    @Input() enrollment: BeneficiaryInfo
    @Input() disabled: boolean = false
    //periodSelected = ''
    //reasonCode: string = ''
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    validatedDate = new ValidatedDateTextField()
    //public rblvalidPeriod: ValidatedRadioButtonModel[] = []
    //public rblGrp: ValidatedRadioButtonModel[] = []
    //public rblPlan: ValidatedRadioButtonModel[] = []
    //public rblSameState: ValidatedRadioButtonModel[] = []
    public rblLanguage: ValidatedRadioButtonModel[] = []
    //public rdBtnEOB: ValidatedRadioButtonModel[] = []
    public rblSecondaryCoverage: ValidatedRadioButtonModel[] = []
    public rbllongTerm: ValidatedRadioButtonModel[] = []
    //benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    //residentialAddress: AddressDB = {} as AddressDB
    //mailingAddress: AddressDB = {} as AddressDB
    //public IsRblvalidPeriodYes: boolean
    //public IsRblvalidPeriodNo: boolean
    //public IsRblGrpYes: boolean
    //public IsRblGrpNo: boolean
    //public IsRblSameStateNo: boolean
    //public IsRblSameStateYes: boolean
    //genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    //titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    //titleOption: string = ""
    //genderOption: string = ""
    notBlankValidator = new NotBlankGenericFieldValidator()
    phoneNumberInputMask = new PhoneNumberInputMask()
    dateTextFieldValidator = new DateTextFieldValidator()
    numericTextFieldValidator = new NumericTextFieldValidator()
    requiredRadioButtonValidator = new RequiredRadioButtonFieldValidator()
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    //drugPlanModel = {} as DrugPlan
    //states: State[] = [] as State[]
    //mailingstates: State[] = [] as State[]
    //public optionrbPlan: ValidatedRadioButtonModel[] = []
    public showsubmit: boolean
    //public sameAsBusinessAddress = false
    //public ispobox: boolean
    planYear: number
    //planList: PlanList[] = [] as PlanList[]
    //selPlan: string
    //AppDate: Date
    //EffectiveDate: Date
    IsCovergInfoYes: boolean
    IsCovergInfotext: boolean
    hasError: boolean
    ErrorMessages: any[]
    IsEobYes: boolean
    IsEobNo: boolean
    IsRbllongtermYes: boolean
    //IsSameAddress: boolean
    agentUserName: string
    isQtip: boolean
    planstatename: string
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyouthey: string
    spnyourhisher: string
    spnyourtheir: string
    spnYourBeneficiaryNew: string
    AgentFullName: string
    //dateField: boolean
    eobName: string
    insuranceComapny: string
    //appState: string
    //mailState: string
    //checkPlanyear: boolean = false
    //isAEPVisible: boolean
    spndodoes: string
    spnyouhimher: string
    spnyouthem: string
    spnIsBeneficiaryYou: string
    spntheenrolleeYou: string
    spnyoubenef: string
    spnYouheshe: string
    spnYoutheenrollee: string
    spnnameofMedicare: string
    showQtip: boolean = false
    //disableEffectiveDate: boolean
    public rdlHMO: ValidatedRadioButtonModel[] = []
    public rblRep: ValidatedRadioButtonModel[] = []
    public rblStillProceed: ValidatedRadioButtonModel[] = []
    public IsRdlHMOYes: boolean
    public IsRblRepYes: boolean
    public IsRblRepNo: boolean
    public IsProceedNo: boolean
    ShowCurrentYearScript: boolean = false
    effectiveDate: string
    spnYouhesheCaps: string
    spnYourenrollee: string
    planName: string
    accessibilityValue: string
    optionaccessibility: ValidatedRadioButtonModel[] = []

    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private _licenseAppGateway: LicenseApptGateway,
        public _global: PortalGlobals,
        private router: Router,
        private _stateGateway: StateGateway,
        private _callStartGateway: callStartGateway
    ) {
        //  this.enrollmentViewModel.APPDT = moment.utc().format('MM/DD/YYYY')
        this.spnIsBeneficiary = ' enrollee '
        //this.rblvalidPeriod.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        //this.rblGrp.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        //this.rblPlan.push({ value: 'SilverScriptChoice', htmlLabel: 'SilverScript Choice' }, { value: 'SilverScriptPlus', htmlLabel: 'SilverScript Plus' })
        //this.rblSameState.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblLanguage.push(
            { value: 'English', htmlLabel: 'English' },
            { value: 'Spanish', htmlLabel: 'Spanish' },
            { value: 'Other', htmlLabel: 'Other' }
        )
        //     this.rdBtnEOB.push({ value: 'Yes', htmlLabel: 'YES, ' + this.spnIsBeneficiary + ' would like to receive Explanation of Benefits statements electronically' }, { value: 'No', htmlLabel: 'NO, ' + this.spnIsBeneficiary + ' would like to receive Explanation of Benefits statements by mail' })
        this.rblSecondaryCoverage.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rbllongTerm.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rdlHMO.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblRep.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblStillProceed.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.optionaccessibility.push(
            { value: '2', htmlLabel: 'Braille' },
            { value: '1', htmlLabel: 'Large Print' },
            { value: '4', htmlLabel: 'Audio CD' }
        )

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.optionaccessibility.push({ value: '8', htmlLabel: 'Data CD' })
        }
        this.accessibilityValue = ''

        //this.IsRblvalidPeriodYes = false
        //this.IsRblvalidPeriodNo = false
        //this.IsRblGrpYes = false
        //this.IsRblGrpNo = false
        //this.IsRblSameStateYes = false
        //this.IsRblSameStateNo = false
        this.showsubmit = false
        this.IsCovergInfoYes = false
        this.IsCovergInfotext = false
        //this.IsSameAddress = true
        this.isQtip = false
        this.IsRdlHMOYes = false
        this.IsRblRepYes = false
        this.IsRblRepNo = false
        this.IsProceedNo = false
        this.planstatename = '(state name)'
        this.ErrorMessages = [] as any[]
        //this.disableEffectiveDate = false
    }
    onBlur() {}

    ngOnInit() {
        this.showQtip = false
        this.hasError = false
        //this.isAEPVisible = false
        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (this._global.selectedPlanYear !== undefined) {
            this.planYear = this._global.selectedPlanYear
        }

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }

        if (this._global.currentUser.userProfileName !== undefined) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.planName = this.enrollmentViewModel.PLANTYPENAME
        this.setData()
        //this.loadPlanList()
    }

    SalesBenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/BeneficiaryDetails/6'])
    }

    onAccessibilityChanges(value) {
        this.accessibilityValue = value
        this.enrollmentViewModel.accessibility = value
    }

    //getLicensedStates() {
    //    this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this.enrollmentViewModel.AGENTNAME)
    //        .subscribe(state => {
    //            for (let i = 0; i < state.length; i++) {
    //                this.states.push({ value: state[i].value, text: state[i].text })
    //            }
    //            this.states.unshift({ value: 0, text: '-- Choose One --', })
    //            if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0' || this.enrollmentViewModel.APPST === null) {
    //                this.enrollmentViewModel.APPST = '0'
    //            }

    //            this.getAllStates()

    //        })
    //}

    //getAllStates() {
    //    this._stateGateway.getAllStates().subscribe(
    //        (states: State[]) => {
    //            states.unshift({ value: 0, text: '-- Choose One --', })

    //            _.remove(states, function (states) { return (states.value === 'PR' || states.value === 'VI') });

    //            this.mailingstates = states
    //            //  this.states = states
    //            // if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
    //            //    this.enrollmentViewModel.APPST = '0'
    //            // }
    //            if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0' || this.enrollmentViewModel.MAILST === null) {
    //                this.enrollmentViewModel.MAILST = '0'
    //            }
    //            this.setData()
    //            // this.mailingstates.unshift({ value: 0, text: '-- Choose One --', })
    //        }
    //    )

    //}

    setData() {
        //this.titleOptions = [
        //    { value: 'MR', text: 'MR' },
        //    { value: 'MRS', text: 'MRS' },
        //    { value: 'DR', text: 'DR' },
        //    { value: 'MS', text: 'MS' }
        //]

        //this.genderOptions = [
        //    { value: 'M', htmlLabel: 'M', disabled: this.disabled },
        //    { value: 'F', htmlLabel: 'F', disabled: this.disabled }
        //]
        //if (this.enrollmentViewModel.PLANYEAR === '2019') {
        //    this.checkPlanyear = true
        //}
        //else {
        //    this.checkPlanyear = false
        //}
        this.AgentFullName =
            (this.enrollmentViewModel.APPFN === null ? '' : this.enrollmentViewModel.APPFN) +
            ' ' +
            (this.enrollmentViewModel.APPLN === null ? '' : this.enrollmentViewModel.APPLN)
        this.setScript()
        if (
            (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '') ||
            (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '')
        ) {
            this.eobName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
        } else {
            this.eobName = ' enrollee'
        }

        if (this.enrollmentViewModel.EFFDT !== undefined && this.enrollmentViewModel.EFFDT !== null) {
            this.effectiveDate = moment(this.enrollmentViewModel.EFFDT).format('MM/DD/YYYY')
        }

        if (this.enrollmentViewModel.PLANTYPENAME !== undefined) {
            this.planName = this.enrollmentViewModel.PLANTYPENAME
        }

        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === null || this.enrollmentViewModel.LANG === '') {
            //default to English
            this.enrollmentViewModel.LANG = 'English'
        }

        if (
            this.enrollmentViewModel.RBLLONGTERM !== '' &&
            this.enrollmentViewModel.RBLLONGTERM !== null &&
            this.enrollmentViewModel.RBLLONGTERM !== undefined
        ) {
            this.ShowrbllongtermOptions(this.enrollmentViewModel.RBLLONGTERM)
        }
        if (this.enrollmentViewModel.OTHCVRG !== '' && this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            this.ShowCoverageInfo(this.enrollmentViewModel.OTHCVRG)
        }
        this.setAccessibility(this.enrollmentViewModel.EOB)
        this.setEOB()

        this.ShowEobEmail(this.enrollmentViewModel.EOB === 'EEOB')

        if (
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== '' &&
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== null &&
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== undefined
        ) {
            this.ShowGroupOptionsHEALTHCOVERAGE(this.enrollmentViewModel.RBLHEALTHCOVERAGE)
        }
        if (
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== undefined &&
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== null &&
            this.enrollmentViewModel.RBLLIS !== ''
        ) {
            this.ShowOptionsStillProceed(this.enrollmentViewModel.RBLLIS)
        }
        if (this.enrollmentViewModel.RBLHMO !== '' && this.enrollmentViewModel.RBLHMO !== null && this.enrollmentViewModel.RBLHMO !== undefined) {
            this.ShowOptionsHMO(this.enrollmentViewModel.RBLHMO)
        }
        if (
            this.enrollmentViewModel.CALLOGID !== 0 &&
            this.enrollmentViewModel.CALLOGID !== null &&
            this.enrollmentViewModel.CALLOGID !== undefined
        ) {
            this.isQtip = true
        }
    }
    ShowrbllongtermOptions(val: any) {
        if (val === 'Yes') {
            this.IsRbllongtermYes = true
        }
        if (val === 'No') {
            this.IsRbllongtermYes = false
        }
        this.enrollmentViewModel.RBLLONGTERM = val
    }
    ShowCoverageInfo(val: any) {
        if (val === 'Yes') {
            this.IsCovergInfoYes = true
            this.IsCovergInfotext = true
            //   this.showsubmit = true
        }
        if (val === 'No') {
            this.IsCovergInfoYes = false
            this.IsCovergInfotext = false
            //  this.showsubmit = true
        }
        this.enrollmentViewModel.OTHCVRG = val
    }
    ShowEobEmail(SelEob: boolean) {
        if (SelEob) {
            this.IsEobYes = true
            this.IsEobNo = false
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.IsEobYes = false
            this.IsEobNo = true
            this.enrollmentViewModel.EOB = 'PEOB'
        }
    }

    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step3'])
    }
    formSubmit(): void {
        this.ErrorMessages = [] as any[]
        this.enrollmentViewModel.AGENTDEX = 'Phone'
        this.enrollmentViewModel.DEX = 'AGNTP'
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '44'
        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
        //this.enrollmentViewModel.PLANST = this.enrollmentViewModel.APPST
        if (this.enrollmentViewModel.POBOX) {
            this.enrollmentViewModel.POVERIND = '1'
        } else {
            this.enrollmentViewModel.POVERIND = '0'
        }
        if (this.IsEobYes) {
            this.enrollmentViewModel.LANGFORMAT = 'EEOB'
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.enrollmentViewModel.LANGFORMAT = 'PEOB'
            this.enrollmentViewModel.EOB = 'PEOB'
        }
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
        }
        // Set  Access
        this.enrollmentViewModel.EOB = this.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility)

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (!this.isFormInvalid()) {
            this._enrollementGateway.UpdateEnrollmentData(this.enrollmentViewModel).subscribe((model: SubmitEnrollmentDataResponse) => {
                let response = model
                if (response !== undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = true

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                    } else {
                        if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                            this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                            this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step5'])
                        } else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        }
                    }
                } else {
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
            })
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
        // this.validateForm()
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    validateForm() {}
    isFormInvalid(): boolean {
        this.hasError = false
        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === '') {
            this.ErrorMessages.push('Preferred Language is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.RBLLONGTERM === undefined || this.enrollmentViewModel.RBLLONGTERM === '') {
            this.ErrorMessages.push('Long Term Care Facility is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.RBLLONGTERM === 'Yes') {
            if (this.enrollmentViewModel.LTCFACILITY === undefined || this.enrollmentViewModel.LTCFACILITY === '') {
                this.ErrorMessages.push('Institution Name is required.')
                this.hasError = true
            }
        }
        if (
            this.enrollmentViewModel.LTCFACILITY !== undefined &&
            this.enrollmentViewModel.LTCFACILITY !== '' &&
            this.enrollmentViewModel.LTCFACILITY !== null
        ) {
            let checkltcfacility = this.enrollmentViewModel.LTCFACILITY,
                regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
            let isLtcFacility = regexCovGroupVal.test(checkltcfacility)
            if (!isLtcFacility) {
                this.hasError = true
                this.ErrorMessages.push('Institution Name is invalid')
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === 'Yes') {
            if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                this.ErrorMessages.push('Secondary Coverage Name is required')
                this.hasError = true
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === 'Yes') {
            if (
                this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                this.enrollmentViewModel.OTHCVRGNAME !== null
            ) {
                let regexCoverageName = /^[A-Za-z\s\-\' ]+$/
                let checkCoverageName = this.enrollmentViewModel.OTHCVRGNAME,
                    regexCoverageNameVal = new RegExp(regexCoverageName)
                let isCovnameValid = regexCoverageNameVal.test(checkCoverageName)
                if (!isCovnameValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid Secondary Coverage')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGID !== undefined &&
                this.enrollmentViewModel.OTHCVRGID !== '' &&
                this.enrollmentViewModel.OTHCVRGID !== null
            ) {
                let checkCoverageID = this.enrollmentViewModel.OTHCVRGID,
                    regexCoverageIDVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovIDValid = regexCoverageIDVal.test(checkCoverageID)
                if (!isCovIDValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid ID# for Secondary Coverage')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                this.enrollmentViewModel.OTHCVRGGRP !== null
            ) {
                let checkCoverageGroup = this.enrollmentViewModel.OTHCVRGGRP,
                    regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovGroupValid = regexCovGroupVal.test(checkCoverageGroup)
                if (!isCovGroupValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid Group for Secondary Coverage')
                }
            }
            if (this.enrollmentViewModel.COBBIN !== undefined && this.enrollmentViewModel.COBBIN !== '' && this.enrollmentViewModel.COBBIN !== null) {
                let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                    regexcheckCOBBINVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isRxBinValid = regexcheckCOBBINVal.test(checkCOBBIN)
                if (!isRxBinValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid RxBIN for Secondary Coverage')
                }
            }

            if (this.enrollmentViewModel.COBPCN !== undefined && this.enrollmentViewModel.COBPCN !== '' && this.enrollmentViewModel.COBPCN !== null) {
                let checkCOBPCN = this.enrollmentViewModel.COBPCN,
                    regexCOBPCNVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCOBPCNValid = regexCOBPCNVal.test(checkCOBPCN)
                if (!isCOBPCNValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid RxPCN for Secondary Coverage')
                }
            }

            if (
                this.enrollmentViewModel.COBEFFDT !== undefined &&
                this.enrollmentViewModel.COBEFFDT !== null &&
                this.enrollmentViewModel.COBTERMDT !== undefined &&
                this.enrollmentViewModel.COBTERMDT !== null
            ) {
                let ed = moment(this.enrollmentViewModel.COBEFFDT).format('MM/DD/YYYY')
                let td = moment(this.enrollmentViewModel.COBTERMDT).format('MM/DD/YYYY')
                if (moment(ed).toDate() > moment(td).toDate()) {
                    this.hasError = true
                    this.ErrorMessages.push('Effective Date for coverage cannot be greater than Termination Date')
                }
            }
        }
        if (
            this.enrollmentViewModel.EOB === 'EEOB' ||
            this.enrollmentViewModel.EOB === '5' ||
            this.enrollmentViewModel.EOB === '6' ||
            this.enrollmentViewModel.EOB === '7' ||
            this.enrollmentViewModel.EOB === '9'
        ) {
            if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
                this.ErrorMessages.push('Email Address is required for Paperless Documents')
                this.hasError = true
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.APPEMAIL !== undefined &&
            this.enrollmentViewModel.APPEMAIL !== '' &&
            this.enrollmentViewModel.APPEMAIL !== null
        ) {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()
            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.ErrorMessages.push('Email Address is invalid.')
            }
        }

        if (
            this.enrollmentViewModel.RBLHEALTHCOVERAGE === undefined ||
            this.enrollmentViewModel.RBLHEALTHCOVERAGE === '' ||
            this.enrollmentViewModel.RBLHEALTHCOVERAGE === null
        ) {
            this.ErrorMessages.push('Please select health coverage')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }

        // check authorize reprenatative
        if (this.enrollmentViewModel.RBLHMO === undefined || this.enrollmentViewModel.RBLHMO === '' || this.enrollmentViewModel.RBLHMO === null) {
            this.ErrorMessages.push('Please select member advantage plan')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }

        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    setScript() {
        if (this.enrollmentViewModel.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyouthey = 'you'
            this.spnyourhisher = 'your'
            this.spnyourtheir = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnIsBeneficiaryYou = 'you'
            this.spntheenrolleeYou = 'You'
            this.spnyouhimher = 'you'
            this.spnyouthem = 'you'
            this.spndodoes = 'do'
            this.spnyoubenef = 'you'
            this.spnYouheshe = 'You'
            this.spnYoutheenrollee = 'you'
            this.spnnameofMedicare = 'you'
            this.spnYouhesheCaps = 'You'
            this.spnYourenrollee = 'your'
        }
        if (
            this.enrollmentViewModel.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== 'undefined undefined' &&
            this.AgentFullName !== ''
        ) {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spnIsBeneficiaryYou = 'the enrollee'
            this.spntheenrolleeYou = 'The enrollee’s'
            this.spndodoes = 'does'
            this.spnyoubenef = 'the beneficiary'
            this.spnYoutheenrollee = this.AgentFullName
            this.spnnameofMedicare = this.AgentFullName
            this.spnYourenrollee = 'the enrollee'

            if (this.enrollmentViewModel.TITLE === 'Mr' || this.enrollmentViewModel.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
                this.spnYouhesheCaps = 'He'
                this.spnyouthey = 'they'
                this.spnyourtheir = 'their'
                this.spnyouthem = 'them'
            } else if (
                this.enrollmentViewModel.TITLE === 'Mrs' ||
                this.enrollmentViewModel.TITLE === 'Ms' ||
                this.enrollmentViewModel.APPGEN === 'F'
            ) {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
                this.spnYouhesheCaps = 'She'
                this.spnyouthey = 'they'
                this.spnyourtheir = 'their'
                this.spnyouthem = 'them'
            } else {
                this.spnyouheshe = 'he/she'
                this.spnyourhisher = 'his/her'
                this.spnyouhimher = 'him/her'
                this.spnYouheshe = 'he/she'
                this.spnYouhesheCaps = 'He/She'
                this.spnyouthey = 'they'
                this.spnyourtheir = 'their'
                this.spnyouthem = 'them'
            }
        }
        if (
            this.enrollmentViewModel.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiary = 'enrollee’s name'
            this.spnIsAre = ' is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = 'he/she'
            this.spnyourhisher = 'his/her'
            this.spnIsBeneficiaryYou = 'the enrollee'
            this.spntheenrolleeYou = 'The enrollee’s'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = 'him/her'
            this.spndodoes = 'does'
            this.spnyoubenef = 'the beneficiary'
            this.spnYouheshe = 'he/she'
            this.spnYoutheenrollee = 'the enrollee name'
            this.spnnameofMedicare = 'name of Medicare beneficiary'
            this.spnYouhesheCaps = 'He/She'
            this.spnYourenrollee = 'the enrollee'
            this.spnyouthey = 'they'
            this.spnyourtheir = 'their'
            this.spnyouthem = 'them'
        }
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    ShowGroupOptionsHEALTHCOVERAGE(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsRblRepYes = true
            this.IsRblRepNo = false
            this.showsubmit = false
        }
        if (isgroup === 'No') {
            this.IsRblRepYes = false
            this.IsRblRepNo = true
            this.showsubmit = true
            this.enrollmentViewModel.RBLLIS = ''
            this.IsProceedNo = false
        }

        this.enrollmentViewModel.RBLHEALTHCOVERAGE = isgroup
    }
    ShowOptionsHMO(ishmo: string) {
        if (ishmo === 'Yes') {
            this.IsRdlHMOYes = true
        }
        if (ishmo === 'No') {
            this.IsRdlHMOYes = false
        }
        this.enrollmentViewModel.RBLHMO = ishmo
    }

    ShowOptionsStillProceed(isStillProceed: string) {
        if (isStillProceed === 'Yes') {
            this.IsProceedNo = false
            this.showsubmit = true
        }
        if (isStillProceed === 'No') {
            this.IsProceedNo = true
            this.showsubmit = false
        }
        this.enrollmentViewModel.RBLLIS = isStillProceed
    }

    setEOB() {
        if (
            this.enrollmentViewModel.EOB != undefined &&
            this.enrollmentViewModel.EOB != null &&
            this.enrollmentViewModel.EOB != '' &&
            (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '5' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '6' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '7' ||
                this.enrollmentViewModel.EOB === '9')
        ) {
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.enrollmentViewModel.EOB = 'PEOB'
        }
    }
    setAccessibility(lAccessibility) {
        if (this.accessibilityValue != '' && this.accessibilityValue != undefined) {
            lAccessibility = this.accessibilityValue
        }
        if (lAccessibility == '1' || lAccessibility == '5') {
            this.enrollmentViewModel.accessibility = '1'
        }
        if (lAccessibility == '2' || lAccessibility == '6') {
            this.enrollmentViewModel.accessibility = '2'
        }
        if (lAccessibility == '4' || lAccessibility == '7') {
            this.enrollmentViewModel.accessibility = '4'
        }
        if (lAccessibility == '8' || lAccessibility == '9') {
            this.enrollmentViewModel.accessibility = '8'
        }
        this.accessibilityValue = this.enrollmentViewModel.accessibility
    }
    SetLanFormat(eob: string, selectedAccessibility: string): string {
        // Set  Access
        this.accessibilityValue = selectedAccessibility

        if (eob == 'EEOB' || eob == 'PEOB') {
            if (this.accessibilityValue != undefined && this.accessibilityValue != '') {
                if (this.accessibilityValue == '1') {
                    if (eob == 'EEOB') {
                        eob = '5'
                    } else {
                        eob = '1'
                    }
                }
                if (this.accessibilityValue == '2') {
                    if (eob == 'EEOB') {
                        eob = '6'
                    } else {
                        eob = '2'
                    }
                }
                if (this.accessibilityValue == '4') {
                    if (eob == 'EEOB') {
                        eob = '7'
                    } else {
                        eob = '4'
                    }
                }
                if (this.accessibilityValue == '8') {
                    if (eob == 'EEOB') {
                        eob = '9'
                    } else {
                        eob = '8'
                    }
                }
            }
        }
        return eob
    }
}
